export const getDefaultSorted = [
  {
    dataField: 'name',
    order: 'asc',
  },
];

const getSizePerPageList = (totalLength = 0) => [
  { text: '5', value: 5 },
  { text: '10', value: 10 },
  { text: '15', value: 15 },
  { text: '20', value: 20 },
  { text: '25', value: 25 },
  { text: 'All', value: totalLength },
];

export const getPageOptions = (totalLength = 0) => ({
  sizePerPage: 10,
  totalSize: totalLength,
  custom: true,
  sizePerPageList: getSizePerPageList(totalLength),
});
